<template>
    <client-page>

        <sub-visual
        sh="What We Do"
        tabActive="Quality Control"
        bg="/images/sub/visual/sv4.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <div class="page-tit-wrap">
                    <h2 class="page-tit">
                        Quality Control
                    </h2>
                    <p>
                        ISO 9001 품질경영 시스템 절차에 따른  전체 공정의 체계적이고 효율적인 품질관리 시스템 운영 <br class="d-none d-md-block">
                        SPC 시스템을 통한 트렌드 분석으로 안정적인 품질 확보
                    </p>
                </div>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <sub-line-layout tit="품질 관리">
                    <v-img src="/images/sub/wwd/control/control-img.png" max-width="940" class="mx-auto d-none d-md-block"></v-img>
                    <v-img src="/images/sub/wwd/control/control-img-mo.png" max-width="670" class="mx-auto d-block d-md-none"></v-img>
                </sub-line-layout>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/ko/sub/sub-line-layout.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
    },
};
</script>

<style lang="scss" scoped>
</style>